/** The scopes a tailnet's Tailscale credential needs, in the order the
 * installer lists them. They're the connector's `TAILSCALE_REQUIRED_SCOPES`
 * (p0-connector-tailscale), which its install check requires. The backend's
 * tests keep the two the same. */
export const TAILSCALE_SCOPES: readonly string[] = [
  "policy_file:read",
  "users:read",
  "devices:core:read",
  "devices:posture_attributes",
  "devices:routes:read",
  "services:read",
];
